/*
  import { ownerStatementsStore } from '@/services/OwnerStatements/store'
*/

import Vue from 'vue'
import Vuex from 'vuex'

import { notifyProblem } from '@/services/notify'
import kms from '@/services/kms'

const isDebug = true

/* eslint-disable no-empty-pattern */
const actions = {
  /*
    const { list } = await ownerStatementsStore.dispatch ('getOwnerStatementList', {
      hoaId
    });
  */

  async getOwnerStatementList({}, { ownerID }) {
    console.log('in getOwnerStatementList...' + ownerID)
    try {
      const results = await kms.get('/AccountsReceivable/OwnerStatement/List', {
        params: {
          ownerID
        }
      })

      if (isDebug == true)
        console.debug('getOwnerStatementList log=' + JSON.stringify(results.results))

      return {
        list: results.results
      }
    } catch (exception) {
      notifyProblem(`The Owner Statements list could not be retrieved.`)
      console.error(exception)
    }

    return {
      list: []
    }
  },

  async getDocumentFile({ dispatch }, { params, done }) {
    const path = `/AccountsReceivable/OwnerStatement/GetFile`
    const result = await kms.get(path, {
      params
    })

    if (this.isDebug == true) console.debug('getDocumentFile=' + JSON.stringify(result))

    if (dispatch && dispatch != undefined) console.debug(dispatch)

    if (result) {
      console.debug(`Successfully retrieved the owner statement.`)
      done({ details: result })
    } else {
      console.error('There was a problem retrieving the owner statement.')
    }
  }
}
/* eslint-enable no-empty-pattern */

Vue.use(Vuex)
export const ownerStatementsStore = new Vuex.Store({
  state: {},
  mutations: {},
  getters: {},
  actions
})
